'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactackleIcons = require('reactackle-icons');

var _reactackleCore = require('reactackle-core');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var titleFontSize = _reactackleCore.fontSize[-1];
var titleLineHeight = 1.5;
var titlePadY = _reactackleCore.baseModule;

exports.default = {
  item: {
    title: {
      align: 'top', // One of: top, center, bottom, stretch
      minHeight: function minHeight(base) {
        return titleFontSize * titleLineHeight + titlePadY(base) * 2;
      },

      collapsed: {
        backgroundColor: _reactackleCore.colorWhite,
        opacity: 0.7,
        fontSize: titleFontSize,
        lineHeight: 1.5,
        fontWeight: _reactackleCore.fontWeightNormal,
        color: _reactackleCore.bodyFontColor,
        textTransform: 'uppercase',
        paddingTop: (0, _reactackleCore.bmodule)(1),
        paddingBottom: (0, _reactackleCore.bmodule)(1),
        paddingLeft: (0, _reactackleCore.bmodule)(2),

        hover: {
          backgroundColor: _reactackleCore.colorPaletteGrey50,
          opacity: 1
        },

        focus: {
          backgroundColor: _reactackleCore.colorPaletteGrey75,
          opacity: 1
        }
      },

      expanded: {
        backgroundColor: _reactackleCore.colorWhite,
        opacity: 1,
        fontSize: titleFontSize,
        lineHeight: 1.5,
        fontWeight: _reactackleCore.fontWeightSemibold,
        color: _reactackleCore.bodyFontColor,
        textTransform: 'uppercase',
        paddingTop: (0, _reactackleCore.bmodule)(1),
        paddingBottom: (0, _reactackleCore.bmodule)(1),
        paddingLeft: (0, _reactackleCore.bmodule)(2),
        paddingRight: (0, _reactackleCore.bmodule)(2),

        hover: {
          backgroundColor: _reactackleCore.colorPaletteGrey50,
          opacity: 1
        },

        focus: {
          backgroundColor: _reactackleCore.colorPaletteGrey75,
          opacity: 1
        }
      }
    },

    expandIcon: {
      height: 24,
      width: null,
      imgHeight: 20,
      imgWidth: null,

      expanded: {
        opacity: 1,
        rotateDegree: '90deg',
        iconElement: _react2.default.createElement(_reactackleIcons.IconArrowChevronRight, { size: 'custom', color: 'currentColor' })
      },

      collapsed: {
        opacity: 0.7,
        rotateDegree: 0,
        iconElement: _react2.default.createElement(_reactackleIcons.IconArrowChevronRight, { size: 'custom', color: 'currentColor' })
      }
    },

    content: {
      paddingY: (0, _reactackleCore.bmodule)(1.5),
      paddingX: (0, _reactackleCore.bmodule)(2),
      animatedOffset: -20
    }
  },
  separator: {
    style: 'solid',
    color: _reactackleCore.colorBorder,
    thickness: 1
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/reactackle-accordion/dist/styles/theme.js
// module id = 513
// module chunks = 0